import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "app" }
const _hoisted_2 = { class: "wrapAll" }
const _hoisted_3 = { class: "wrapMiddle" }
const _hoisted_4 = { class: "side-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "kazuki", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "yoshida", -1)
const _hoisted_7 = { class: "side-sns" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "side-desc" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "side-buttons" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("about")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("blog")
const _hoisted_16 = { class: "side-lang" }
const _hoisted_17 = { class: "wrapContent" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "footer footer-white" }, " © 2022 KazukiYoshida ", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["wrapSide", _ctx.topPageFlg ? '' : 'hideShow'])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: _ctx.$C.route.home
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "sns",
              href: _ctx.$C.link.twitter_url,
              target: "_blank"
            }, [
              _createVNode(_component_fa, { icon: ['fab', 'twitter'] })
            ], 8, _hoisted_8),
            _createElementVNode("a", {
              class: "sns",
              href: _ctx.$C.link.github_url,
              target: "_blank"
            }, [
              _createVNode(_component_fa, { icon: ['fab', 'github'] })
            ], 8, _hoisted_9),
            _createElementVNode("a", {
              class: "sns",
              href: _ctx.$C.link.instagram_url,
              target: "_blank"
            }, [
              _createVNode(_component_fa, { icon: ['fab', 'instagram'] })
            ], 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              href: _ctx.$C.link.google_maps_url,
              target: "_blank"
            }, [
              _createElementVNode("p", null, _toDisplayString(_ctx.t('top.desc1')), 1)
            ], 8, _hoisted_12),
            _createElementVNode("p", null, _toDisplayString(_ctx.t('top.desc2')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.t('top.desc3')), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: _ctx.$C.route.about,
              class: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: _ctx.$C.route.blog,
              class: "button"
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.locale == 'en')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "lang",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeLang('ja')))
                }, _toDisplayString(_ctx.t('top.changeLang')), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "lang",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang('en')))
                }, _toDisplayString(_ctx.t('top.changeLang')), 1))
          ])
        ], 2),
        _createElementVNode("div", _hoisted_17, [
          true
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_router_view)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["wrapFooter", _ctx.topPageFlg ? '' : 'hideShow'])
      }, _hoisted_20, 2)
    ])
  ]))
}